export enum SeatSelectionType {
  SEATS_FIRST = 0,
  TICKETS_FIRST = 1,
}
